import { Link } from "react-router-dom";
import { useSeo } from "~/lib/seo/useSeo";
import { EntreNaLista } from "~/ui/EntreNaLista";

/**
 * As quatro páginas de volta do e-mail: confirmou, saiu, link quebrado e
 * link velho. São o outro lado do duplo opt-in — o servidor redireciona
 * para cá depois de mexer no banco.
 *
 * Nenhuma delas é indexável nem tem valor de busca; existem para a pessoa
 * saber o que aconteceu. Por isso ficam fora do sitemap e do prerender.
 */

interface MolduraProps {
  titulo: string;
  children: React.ReactNode;
}

function Moldura({ titulo, children }: MolduraProps) {
  useSeo({ title: titulo });
  return (
    <main className="jg-shell py-20 sm:py-28">
      <div className="max-w-[58ch]">{children}</div>
      <p className="mt-12">
        <Link className="jg-link" to="/">
          Voltar para os vídeos
        </Link>
      </p>
    </main>
  );
}

export function ListaConfirmada() {
  return (
    <Moldura titulo="Inscrição confirmada">
      <p className="jg-eyebrow">Lista</p>
      <h1 className="jg-display mt-3 text-4xl sm:text-5xl">
        Pronto. Você está na lista.
      </h1>
      <p className="mt-6 text-lg text-jg-fg-muted">
        Acabei de te mandar um e-mail com o tutorial e o kit completo para
        baixar. Quando sai um vídeo novo, você recebe a explicação escrita e as
        fontes que eu conferi.
      </p>
      <p className="mt-4 text-jg-fg-muted">
        Sair é um clique no rodapé de qualquer mensagem. Não repasso seu
        endereço para ninguém.
      </p>
      <p className="mt-8">
        <Link className="jg-button" to="/tutorial/cabecudo">
          Começar pelo tutorial
        </Link>
      </p>
    </Moldura>
  );
}

export function ListaSaiu() {
  return (
    <Moldura titulo="Você saiu da lista">
      <p className="jg-eyebrow">Lista</p>
      <h1 className="jg-display mt-3 text-4xl sm:text-5xl">
        Você saiu da lista.
      </h1>
      <p className="mt-6 text-lg text-jg-fg-muted">
        Feito na hora, sem perguntas. Não vou te mandar mais nada.
      </p>
      <p className="mt-4 text-jg-fg-muted">
        Os vídeos continuam aqui no site e no{" "}
        <a
          className="jg-link"
          href="https://instagram.com/bittarg"
          rel="noreferrer noopener"
          target="_blank"
        >
          @bittarg
        </a>
        , sem precisar de e-mail. Se mudar de ideia, dá para entrar de novo
        quando quiser.
      </p>
    </Moldura>
  );
}

export function ListaLinkExpirado() {
  return (
    <Moldura titulo="Link expirado">
      <p className="jg-eyebrow">Lista</p>
      <h1 className="jg-display mt-3 text-4xl sm:text-5xl">
        Esse link já venceu.
      </h1>
      <p className="mt-6 text-lg text-jg-fg-muted">
        O link de confirmação vale sete dias — é curto de propósito, para um
        e-mail antigo não virar inscrição sem você querer. Peça outro aqui:
      </p>
      <div className="mt-8">
        <EntreNaLista origem="link-expirado" />
      </div>
    </Moldura>
  );
}

export function ListaLinkInvalido() {
  return (
    <Moldura titulo="Link inválido">
      <p className="jg-eyebrow">Lista</p>
      <h1 className="jg-display mt-3 text-4xl sm:text-5xl">
        Esse link não funciona.
      </h1>
      <p className="mt-6 text-lg text-jg-fg-muted">
        Provavelmente o endereço quebrou em duas linhas no seu programa de
        e-mail e só metade virou link. Dá para tentar de novo daqui:
      </p>
      <div className="mt-8">
        <EntreNaLista origem="link-invalido" />
      </div>
    </Moldura>
  );
}
